// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:07:25

export default {
  "id": "doge-rush-draw-home-puzzle",
  "slug": "doge-rush-draw-home-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/feeeeae827584305941557b175a5408d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/feeeeae827584305941557b175a5408d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Doge Rush Draw Home Puzzle",
      "description": "Welcome to Doge Rush: Draw Home Puzzle! It's full of lovely adventures. There are two ways to play this game. In the Animal family party, you should help the dog and cat find their food and guide them home, drawing a line between the dog and cat's correct food. And avoid them bumping into each other. If they hit, they will get dizzy and the game will fail. ",
      "instructions": "Mouse click or tap to play",
      "genres": [
        "Adventure",
        "Puzzle"
      ],
      "tags": [
        "cat",
        "dog",
        "drawing"
      ]
    },
    "zh-CN": {
      "title": "狗狗冲刺回家拼图",
      "description": "欢迎来到《狗狗冲刺：回家拼图》！这里充满了可爱的冒险。这款游戏有两种玩法。在《动物家族派对》中，你需要帮助狗狗和猫咪找到它们的食物，引导它们回家，通过画出狗狗和猫咪正确食物之间的线条。同时要避免它们相互碰撞。如果它们相撞，它们会头晕，游戏将失败。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "冒险",
        "解谜"
      ],
      "tags": [
        "猫",
        "狗",
        "绘画"
      ]
    },
    "zh-TW": {
      "title": "狗狗衝刺回家拼圖",
      "description": "歡迎來到狗狗衝刺：繪製回家謎題！這裡充滿了可愛的冒險。遊戲有兩種玩法。在動物家族派對中，你應該幫助狗和貓找到它們的食物，並引導它們回家，繪製一條從狗到貓正確食物的線。並且避免它們碰到彼此。如果它們碰到，它們會感到頭暈，遊戲將會失敗。",
      "instructions": "鼠标點擊或輕觸以開始遊戲",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "貓",
        "狗",
        "繪畫"
      ]
    },
    "zh-HK": {
      "title": "狗吉衝刺回家拼圖",
      "description": "歡迎加入Doge Rush: 繪畫回家謎題！這裡充滿可愛的冒險。遊玩此遊戲有兩種方法。在動物家族派對中，你應該幫助狗和貓找到他們的食物，並引導他們回家，畫線連接狗和貓正確的食物。並避免他們相撞。如果他們碰到一起，他們會感到暈眩，遊戲將會失敗。",
      "instructions": "鼠標點擊或輕觸開始遊戲",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "貓",
        "犬",
        "繪畫"
      ]
    },
    "ja": {
      "title": "ドoge Rush ドロウホーム パズル",
      "description": "ドoge Rush: Draw Home Puzzleへようこそ！素晴らしい冒険がいっぱいです。このゲームには2つのプレイ方法があります。動物家族パーティで、犬と猫がそれぞれの食事を見つけ、家に導くお手伝いをし、犬と猫の正しい食事の間に線を引きましょう。そして、彼らがぶつかるのを避けましょう。もしぶつかると、回転してゲームが失敗します。",
      "instructions": "マウスクリックまたはタップしてゲームを始めます",
      "genres": [
        "アドベンチャー",
        "パズル"
      ],
      "tags": [
        "猫",
        "犬",
        "絵画"
      ]
    },
    "ko": {
      "title": "도지 런 드로우 홈 퍼즐",
      "description": "도그 러시: 드로우 하우스 퍼즐에 오신 것을 환영합니다! 이 게임은 사랑스러운 모험들이 가득합니다. 이 게임을 플레이하는 방법이 두 가지 있습니다. 동물 가족 파티에서는 개와 고양이가 그들의 음식을 찾고 가지고 돌아가도록 도와야 합니다. 개와 고양이의 올바른 음식 사이에 선을 그려야 합니다. 그리고 서로 부딪히지 않도록 해야 합니다. 만약 부딪혀서 멀쩡하지 않아지면 게임이 실패합니다.",
      "instructions": "마우스 클릭이나 탭하여 게임을 시작하세요.",
      "genres": [
        "모험",
        "퍼즐"
      ],
      "tags": [
        "고양이",
        "개",
        "그림"
      ]
    },
    "fr": {
      "title": "Course de Doge Ramène le Puzzle",
      "description": "Bienvenue dans Doge Rush : Puzzle de la Maison ! Il est plein de merveilleuses aventures. Il y a deux manières de jouer à ce jeu. Dans la fête de la famille animale, vous devez aider le chien et le chat à trouver leur nourriture et les guider à la maison, en dessinant une ligne entre la nourriture correcte du chien et du chat. Et éviter qu'ils ne se percutent. Si ils se touchent, ils deviendront étourdis et le jeu échouera.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Aventure",
        "Puzzle"
      ],
      "tags": [
        "chat",
        "chien",
        "dessin"
      ]
    }
  }
};
